<template>
  <div id="views-landing" class="ngo-main-page">
    <section class="hero-section">
      <img
        class="hero-background"
        src="../../../assets/ngoimgs/landing page.png"
        alt="Nigeria health partners platform"
      />

      <div class="hero-overlay"></div>

      <div class="hero-content">
        <div class="hero-badge">
          <img
            src="../../../assets/ngoimgs/Coat-of-arms.png"
            class="hero-badge__image"
            alt="Coat of arms"
          />
          <div>
            <span class="hero-badge__eyebrow">Federal Ministry of Health</span>
            <span class="hero-badge__subtext">DHPRS digital coordination platform</span>
          </div>
        </div>

        <div class="hero-copy">
          <p class="hero-kicker">National Health Inventory</p>
          <h1>Welcome to Nigeria Health Partners' Projects and Data Mapping Platform</h1>
          <p class="hero-description">
            Mapping health partners, projects, data activities, and NGO registrations across Nigeria
            through one modern national workspace.
          </p>
        </div>
      </div>
    </section>

    <section class="tracking-section container" aria-labelledby="tracking-heading">
      <div class="tracking-shell">
        <div class="section-heading">
          <p class="section-kicker">Organization Lookup</p>
          <h2 id="tracking-heading">Find an organization by tracking ID</h2>
          <p class="tracking-description">
            Enter your organization's tracking ID to look up its registration.
          </p>
        </div>
        <form class="tracking-form" @submit.prevent="searchByTrackingId">
          <div class="tracking-field">
            <label for="organization-tracking-id">Tracking ID</label>
            <input
              id="organization-tracking-id"
              v-model="trackingId"
              class="form-control"
              type="text"
              placeholder="Enter tracking ID"
              required
            />
          </div>
          <button class="btn btn-success" type="submit" :disabled="!trackingId.trim()">
            <i class="fa fa-search mr-2" aria-hidden="true"></i>
            Search organization
          </button>
        </form>
      </div>
    </section>

    <section id="card-section" class="landing-services container">
      <div class="section-heading">
        <div>
          <p class="section-kicker">Platform Services</p>
          <h2>Explore the core health inventory</h2>
        </div>
      </div>

      <div class="row service-grid">
        <div class="col-12 col-md-6 col-xl-3 mb-4">
          <Cards coming-soon>
            <template v-slot:image>
              <img src="../../../assets/ngoimgs/book.png" class="img-fluid card-icon" width="50" />
            </template>
            <template v-slot:paragraph>Project Inventory</template>
            <template v-slot:subtitle>Explore and submit health intervention projects.</template>
          </Cards>
        </div>
        <div class="col-12 col-md-6 col-xl-3 mb-4">
          <Cards coming-soon>
            <template v-slot:image>
              <img src="../../../assets/ngoimgs/book.png" class="img-fluid card-icon" width="50" />
            </template>
            <template v-slot:paragraph>Data Inventory</template>
            <template v-slot:subtitle>Explore and submit all health datasets.</template>
          </Cards>
        </div>

        <div class="col-12 col-md-6 col-xl-3 mb-4">
          <Cards coming-soon>
            <template v-slot:image>
              <img
                src="../../../assets/ngoimgs/social-care.png"
                class="img-fluid card-icon"
                width="50"
              />
            </template>
            <template v-slot:paragraph>Stakeholder Inventory</template>
            <template v-slot:subtitle>View a consolidated list of ecosystem stakeholders.</template>
          </Cards>
        </div>

        <div class="col-12 col-md-6 col-xl-3 mb-4">
          <Cards to="ngo/landing">
            <template v-slot:image>
              <img
                src="../../../assets/ngoimgs/Untitled-2.png"
                class="img-fluid card-icon"
                width="50"
              />
            </template>
            <template v-slot:paragraph>NGO Inventory</template>
            <template v-slot:subtitle>
              Register NGOs, submit annual reports, view registered NGOs, and follow the
              registration steps.
            </template>
          </Cards>
        </div>
      </div>
    </section>

    <section id="about-us" class="about-section container">
      <div class="about-shell">
        <NgoInfographic demo />

        <div class="about-copy">
          <p class="section-kicker">About This Site</p>
          <h2>A central digital inventory for health partners, projects, datasets, and NGOs</h2>
          <p id="about-us-paragraph" class="custom-style">
            This central web-based inventory has been developed by the Department of Health
            Planning, Research and Statistics (DHPRS) of the Federal Ministry of Health (FMoH) to
            compile all health data and intervention projects carried out by international partners
            and non-governmental organisations across all health domains in the country.
          </p>
          <p class="custom-style">
            The platform also captures details of Non Governmental Organizations (NGOs) that have
            been registered with the Federal Ministry of Health under the purview of the NGO branch
            at the Health Systems Strengthening division of the DHPRS-FMoH.
          </p>

          <router-link to="ngo/about" class="about-link">
            <span>See more</span>
            <i class="fa fa-angle-right"></i>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { news as NEWS } from '../config/api-modules/api.organization';
import Cards from './bits/bits.index';
import NgoInfographic from './bits/NgoInfographic.vue';

export default {
  name: 'ViewsLanding',
  components: {
    Cards,
    NgoInfographic,
  },
  data() {
    return {
      news: [],
      trackingId: '',
    };
  },
  mounted() {
    NEWS().then((data) => {
      this.news = data.data.results;
    });
  },

  methods: {
    searchByTrackingId() {
      const trackingId = this.trackingId.trim();
      if (!trackingId) return;
      this.$router.push({
        name: 'ngo tracking results',
        query: { tracking_id: trackingId },
      });
    },

    loadLink(link) {
      window.open(link);
    },

    submitdataset() {
      localStorage.setItem('submitdataroute', '/inventory/submit-dataset');
      this.$router.push('/inventory/submit-dataset');
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Raleway:wght@500;600;700&display=swap');

.ngo-main-page {
  padding-top: clamp(1.5rem, 2vw, 2rem);
  padding-bottom: 3rem;
  background: radial-gradient(circle at top left, rgba(48, 171, 76, 0.12), transparent 24%),
    linear-gradient(180deg, #f4faf5 0%, #eef5ef 100%);
  overflow-x: hidden;
}

.hero-section {
  position: relative;
  min-height: 32rem;
  overflow: hidden;
  margin: 0 1rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 32px;
  box-shadow: 0 28px 80px rgba(17, 41, 24, 0.14);
}

.hero-background {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 50% 35%, rgba(33, 74, 47, 0.72), rgba(5, 24, 13, 0.94)),
    linear-gradient(180deg, rgba(9, 32, 17, 0.4), rgba(9, 32, 17, 0.8));
}

.hero-content {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  align-content: center;
  justify-items: center;
  text-align: center;
  gap: 2.5rem;
  min-height: 32rem;
  width: 100%;
  margin: 0 auto;
  padding: clamp(3rem, 4vw, 4.5rem) clamp(1.5rem, 4vw, 4.5rem);
  color: #ffffff;
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  grid-column: 1 / -1;
  width: fit-content;
  padding: 0 0 1.25rem;
  border-bottom: 1px solid rgba(221, 233, 203, 0.25);
  text-align: left;
}

.hero-badge__image {
  width: 56px;
  height: 56px;
  flex-shrink: 0;
  object-fit: contain;
}

.hero-badge__eyebrow,
.hero-badge__subtext,
.hero-kicker,
.section-kicker,
.highlight-card__label {
  display: block;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.hero-badge__eyebrow,
.hero-kicker,
.section-kicker {
  font-size: 0.78rem;
  font-weight: 700;
}

.hero-badge__subtext {
  margin-top: 0.25rem;
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.72);
}

.hero-kicker {
  margin-bottom: 1rem;
  color: #bbd5b7;
  font-size: 0.68rem;
  letter-spacing: 0.22em;
}

.hero-copy {
  width: 100%;
  min-width: 0;
}

.hero-copy h1 {
  width: 100%;
  max-width: 1120px;
  margin: 0 auto 1.5rem;
  font-family: 'Raleway', sans-serif;
  font-size: clamp(2.2rem, 3.3vw, 3.65rem);
  font-weight: 600;
  letter-spacing: -0.035em;
  line-height: 1.18;
  text-wrap: balance;
}

.hero-description {
  width: 100%;
  max-width: 780px;
  margin: 0 auto;
  font-size: clamp(0.95rem, 1.1vw, 1.05rem);
  line-height: 1.8;
  text-wrap: pretty;
  color: rgba(255, 255, 255, 0.84);
}

.highlight-card__label {
  margin-bottom: 0.5rem;
  font-size: 0.72rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.72);
}

.tracking-section,
.landing-services,
.about-section {
  margin-top: 4rem;
}

.tracking-shell {
  padding: 2rem;
  border: 1px solid rgba(24, 57, 31, 0.08);
  border-radius: 28px;
  background: #ffffff;
  box-shadow: 0 24px 60px rgba(20, 55, 31, 0.07);
}

.tracking-description {
  margin: 0.75rem 0 0;
  color: #51685b;
}

.tracking-form {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 1rem;
}

.tracking-field {
  flex: 1 1 240px;
  min-width: 0;
}

.tracking-field label {
  font-weight: 600;
  color: #183322;
}

.tracking-field input,
.tracking-form button {
  min-height: 3rem;
  border-radius: 12px;
}

.tracking-field input:focus {
  border-color: #2c8d41;
  box-shadow: 0 0 0 3px rgba(48, 171, 76, 0.15);
}

.landing-services {
  position: relative;
  z-index: 2;
}

.section-heading {
  margin-bottom: 1.5rem;
}

.section-kicker {
  margin-bottom: 0.45rem;
  color: #2c8d41;
}

.section-heading h2,
.about-copy h2 {
  margin: 0;
  font-family: 'Raleway', sans-serif;
  color: #132218;
}

.service-grid {
  margin-top: 0.5rem;
}

.ngo-main-page ::v-deep .landing-card {
  min-height: 100%;
}

.ngo-main-page ::v-deep .landing-card__subtitle {
  font-size: 0.96rem;
}

.card-icon {
  filter: drop-shadow(0 10px 20px rgba(48, 171, 76, 0.12));
}

#about-us-paragraph {
  color: #090909;
}

.about-shell {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.4rem;
  padding: 2rem;
  border: 1px solid rgba(24, 57, 31, 0.08);
  border-radius: 28px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.94), rgba(245, 250, 246, 0.96)), #ffffff;
  box-shadow: 0 24px 60px rgba(20, 55, 31, 0.07), inset 0 1px 0 rgba(255, 255, 255, 0.72);
}

.about-copy p {
  margin-bottom: 1rem;
  line-height: 1.8;
  color: #51685b;
}

.custom-style {
  font-family: 'Roboto', sans-serif;
}

.about-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.9rem 1.1rem;
  border-radius: 16px;
  background: rgba(48, 171, 76, 0.1);
  color: #1f6f31;
  text-decoration: none;
  font-weight: 700;
}

.about-highlights {
  display: grid;
  gap: 1rem;
}

.highlight-card {
  padding: 1.2rem;
  border: 1px solid rgba(24, 57, 31, 0.08);
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(251, 253, 251, 0.96), rgba(241, 247, 242, 0.96));
}

.highlight-card__label {
  color: #2c8d41;
}

.highlight-card__value {
  color: #183322;
  line-height: 1.5;
}

.submitdataset {
  padding: 0;
  background-color: transparent;
  color: #30ab4c;
  border: none;
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
}

.submitdataset:hover,
.submitdataset:active {
  background-color: transparent !important;
  color: #1f6f31 !important;
  border: none !important;
  box-shadow: none !important;
}

.submitdataset:focus {
  background-color: transparent;
  color: #1f6f31;
  border: none;
  box-shadow: none;
}

@media screen and (max-width: 991px) {
  .ngo-main-page {
    padding-top: clamp(4.5rem, 8vw, 5.5rem);
    padding-bottom: 2.25rem;
  }

  .hero-section,
  .hero-content {
    min-height: auto;
  }

  .hero-content {
    grid-template-columns: 1fr;
    align-items: start;
    gap: 2.25rem;
    padding: 4rem 1.4rem 3rem;
  }

  .about-shell {
    grid-template-columns: 1fr;
  }
}

@media screen and (max-width: 768px) {
  .ngo-main-page {
    padding-top: clamp(4.75rem, 10vw, 5.75rem);
    padding-bottom: 1.5rem;
  }

  .hero-section {
    margin: 0 0.75rem;
    border-radius: 28px;
  }

  .hero-badge {
    max-width: 100%;
  }

  .hero-badge__image {
    width: 56px;
    height: 56px;
  }

  .hero-copy h1 {
    font-size: 2.05rem;
  }

  .hero-description {
    font-size: 0.95rem;
    line-height: 1.7;
  }

  .tracking-section,
  .landing-services,
  .about-section {
    margin-top: 2.5rem;
  }

  .section-heading {
    margin-bottom: 1.15rem;
  }

  .tracking-shell,
  .about-shell {
    padding: 1.25rem;
    border-radius: 22px;
  }

  .page-title {
    font-size: small;
  }
}

@media screen and (max-width: 575px) {
  .tracking-form button {
    width: 100%;
  }

  .ngo-main-page {
    padding-top: 4.75rem;
  }

  .hero-section {
    margin: 0 0.5rem;
    border-radius: 22px;
  }

  .hero-content {
    gap: 2rem;
    padding: 3.4rem 1rem 2.4rem;
  }

  .hero-copy h1 {
    font-size: 1.72rem;
    line-height: 1.22;
  }

  .hero-badge {
    gap: 0.85rem;
    padding: 0 0 1.1rem;
  }

  .hero-badge__eyebrow,
  .hero-kicker,
  .section-kicker {
    letter-spacing: 0.12em;
  }

  .hero-badge__subtext,
  .hero-description,
  .about-copy p,
  .highlight-card__value {
    font-size: 0.9rem;
  }

  .hero-description {
    line-height: 1.65;
  }

  .section-heading h2,
  .about-copy h2 {
    font-size: 1.45rem;
    line-height: 1.2;
  }

  .ngo-main-page ::v-deep .landing-card {
    min-height: 19rem;
    border-radius: 22px;
  }

  .ngo-main-page ::v-deep .landing-card__content {
    padding: 1.15rem;
  }

  .ngo-main-page ::v-deep .landing-card__icon {
    width: 60px;
    height: 60px;
    margin-bottom: 1rem;
    border-radius: 18px;
  }

  .ngo-main-page ::v-deep .landing-card__title {
    font-size: 1rem;
  }

  .ngo-main-page ::v-deep .landing-card__subtitle,
  .ngo-main-page ::v-deep .landing-card__actions {
    font-size: 0.88rem;
    line-height: 1.55;
  }

  .about-shell {
    padding: 1rem;
    border-radius: 18px;
  }
}
</style>
